module.exports = __webpack_public_path__ + "fonts/GalanoGrotesque-Medium.88e3969.woff";